<template>
  <div>
    <iframe id="iframeReport" name="iframeReport" style="height: 0; width: 0"></iframe>
    <section ref="invoice" style="display: none" id="printableArea">
      <v-banner style="text-align:center;" class="subtitle"> Student Report </v-banner>

      <div v-for="(items, index) in report" :key="index">
        <v-row>
          <v-col>Class Name : {{ items.data[0][0].Class }}</v-col>
          <v-col>Total student count : {{ getStudentCount(items.data) }}</v-col>
        </v-row>
        <v-row>
          <v-col>Skills : {{getOptions(items.data[0][0].ClassID,'skills')}} </v-col>
          <v-col> Sub-Skills : {{ getOptions(items.data[0][0].ClassID,'subSkills' )}} </v-col>
           <v-col> Parameter : {{ getOptions(items.data[0][0].ClassID,'parameter' )}} </v-col>
        </v-row>

        <v-row>
          <div class="relative" v-for="(chartData, index2) in items.data" :key="index2">
            <br />
            <div style="padding-left:10px">{{ chartData[0].AcademicTerm }}</div>
            <div style="padding-left:10px">Count :
              {{ getStudentCount(items.data,chartData[0].AcademicTermMapID) }}</div>

            <img :src="graphImages[items.data[0][0].ClassID][chartData[0].AcademicTerm]" alt="" />
          </div>
        </v-row>
        <v-divider></v-divider>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'OnlineClassList',
  props: ['printData', 'chartOptions', 'scaleList', 'graphImages', 'classReports'],
  components: {},
  data () {
    return {
      prtHtml: '',
      report: []
    }
  },

  computed: {},
  watch: {},
  created () {
    Object.keys(this.printData).forEach((classID) => {
      Object.keys(this.printData[classID]).forEach((items2) => {
        let searchIndex = this.report.map((a) => a.classID).indexOf(classID)
        if (searchIndex > -1) {
          this.report[searchIndex].data.push(this.printData[classID][items2])
        } else {
          this.report.push({
            classID: classID,
            data: [this.printData[classID][items2]]
          })
        }
      })
    })
  },
  methods: {
    seriesCount: function (report) {
      let temp = []
      this.scaleList.forEach((ScaleName) => {
        let searchIndex = report.map((a) => a.ScaleName).indexOf(ScaleName)
        if (searchIndex > -1) {
          temp.push(report[searchIndex].Students)
        } else {
          temp.push(0)
        }
      })
      return temp
    },
    getOptions (classId, key) {
      let searchIndex = this.classReports.map((a) => a.id).indexOf(classId)
      let data = this.classReports[searchIndex][key].map((a) => a.name).join(',')
      return data === '' ? 'ALL' : data
    },
    getStudentCount (report, termId = null) {
      let terms = Object.keys(report)
      return terms.reduce((acc, term) => {
        if (termId) {
          // term wise student count
          if (report[term][0].AcademicTermMapID === termId) {
            return (
              acc +
              report[term].reduce((termStudentCount, a) => {
                return termStudentCount + Number(a.Students)
              }, 0)
            )
          } else {
            return acc
          }
        } else {
          // total student count
          return (
            acc +
            report[term].reduce((termStudentCount, a) => {
              return termStudentCount + Number(a.Students)
            }, 0)
          )
        }
      }, 0)
    }
  }
}
</script>
<style scoped>
@media print {
  #printableArea,
  #printableArea * {
    visibility: visible;
  }
  #printableArea {
    position: absolute;
    left: 0;
    top: 0;
  }
  #printableArea1,
  #printableArea1 * {
    visibility: visible;
  }
  #printableArea1 {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
